var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2704 2.28197C18.5755 2.58682 17.8349 2.78889 17.0629 2.887C17.8571 2.41279 18.4633 1.66758 18.7483 0.769373C18.0078 1.21089 17.1902 1.52275 16.3188 1.69679C15.6157 0.948081 14.6135 0.484375 13.5202 0.484375C11.3991 0.484375 9.69146 2.20604 9.69146 4.31667C9.69146 4.62035 9.71716 4.91236 9.78023 5.19035C6.59503 5.035 3.77658 3.50839 1.88321 1.18285C1.55266 1.75635 1.35877 2.41279 1.35877 3.11944C1.35877 4.44632 2.04206 5.62252 3.06058 6.30348C2.44503 6.2918 1.84116 6.11309 1.32957 5.8316C1.32957 5.84328 1.32957 5.85846 1.32957 5.87364C1.32957 7.73548 2.65761 9.28194 4.39914 9.63819C4.08728 9.72346 3.74738 9.76434 3.39464 9.76434C3.14935 9.76434 2.90173 9.75032 2.66929 9.69893C3.1657 11.2162 4.57434 12.3317 6.24929 12.3679C4.94577 13.3876 3.29068 14.0019 1.49893 14.0019C1.18473 14.0019 0.883382 13.9879 0.582031 13.9494C2.27917 15.0438 4.29051 15.6687 6.45954 15.6687C13.5097 15.6687 17.3642 9.82858 17.3642 4.76636C17.3642 4.59699 17.3584 4.43347 17.3502 4.27111C18.1106 3.73149 18.7495 3.05754 19.2704 2.28197Z",
    fill: "#171618"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.e13fb0ba4c082d752423f6afde64df60.svg";
export { ForwardRef as ReactComponent };